// Port of api/fuel/app/classes/filter/search/games/filters/query/rating/disparity/user/group.php
import F from 'offline/filter/constants'
import Util from 'offline/util'
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'rating.disparity.user.group',
	priority: 72,
	require: function(config, filter) {
		return config.ownerType !== F.OWNER_USER && rangeActive(filter.disparity && filter.disparity.user && filter.disparity.user.group, -10, 10)
	},
	run: function(config, filter, data, query) {
		if (!config.userID) return
		query.where('ru.user_id', '=', config.userID)
		query.select('ru.rating_value - AVG(r.rating_value)', 'ug_disparity')
		if (filter.disparity.user.group.from !== -10) {
			query.having('!ug_disparity', '>=', Util.adjustedRating(filter.disparity.user.group.from))
		}
		if (filter.disparity.user.group.to !== 10) {
			query.having('!ug_disparity', '<=', Util.adjustedRating(filter.disparity.user.group.to, true))
		}
	}
}
